import type { SlackAppInfo, SlackSettings } from "metabase-types/api";

import { Api } from "./api";
import { listTag } from "./tags";

export const slackApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    getSlackManifest: builder.query<Record<string, unknown>, void>({
      query: () => ({
        method: "GET",
        url: "/api/slack/manifest",
      }),
    }),
    getSlackAppInfo: builder.query<SlackAppInfo, void>({
      query: () => ({
        method: "GET",
        url: "/api/slack/app-info",
      }),
      providesTags: ["slack-app-info"],
    }),
    updateSlackSettings: builder.mutation<void, Partial<SlackSettings>>({
      query: (settings) => ({
        method: "PUT",
        url: `/api/slack/settings`,
        body: settings,
      }),
      invalidatesTags: [
        "session-properties",
        "slack-app-info",
        listTag("subscription-channel"),
      ],
    }),
  }),
});

export const {
  useGetSlackManifestQuery,
  useGetSlackAppInfoQuery,
  useUpdateSlackSettingsMutation,
} = slackApi;
